// Keep in sync with reactapp/src/pages/ExternalLinkFundraising/campaignBanner.js
export const BANNER_WIDTH = 1920;
export const BANNER_HEIGHT = 280;
export const BANNER_ASPECT = BANNER_WIDTH / BANNER_HEIGHT;
export const BANNER_SIZE_LABEL = `${BANNER_WIDTH}×${BANNER_HEIGHT}`;

export const bannerCssVars = {
  "--campaign-banner-w": BANNER_WIDTH,
  "--campaign-banner-h": BANNER_HEIGHT,
};
